export default __webpack_public_path__ + "static/media/Homepagenewsroom.7a7e46a9.jpg";